<template>
  <section class="form-box quantity-type" :class="{incompleted: qty < 1 || files.length < 1}">
    <div class="container">
      <div class="row">
        <h2 class="urlap-title">Fájlok feltöltése</h2>
      </div>
      <div class="row two-col" v-if="quantityType != 'karakterszam'">
        <h6 class="capital">{{typeLabel}} megadása</h6>
        <div class="form-box-item form-group" :class="{invalid: qty < 1}">
          <input type="number" min="1" v-model.number="qty" class="form-control" name="quantity" placeholder="Mennyiség" :disabled="quantityType == 'karakterszam'">
        </div>
      </div>
      <div class="row" v-if="quantityType == 'karakterszam' && files.length > 0 && false /* disabled! */">
        Vagy karakterszám meghatározása fájlokból <br>
        <button class="btn-secondary btn send-files" type="button" @click="sendToOcr()">
          Fájlok továbbítása feldolgozásra
        </button>
      </div>
      <div class="row" v-if="!srcLanguage">
        <div class="alert alert-warning">
          A <strong>fájlok</strong> feltöltéséhez előbb válasz forrásnyelvet!
        </div>
      </div>
      <div class="row" v-else-if="specialization == ''">
        <div class="alert alert-warning">
          A <strong>fájlok</strong> feltöltése előtt kérjük adja meg a szakterületet vagy a dokumentum típusát.
        </div>
      </div>
      <div class="row" v-else>
        <h6>Fájlok: <span class="desc">(elfogadott típusok: pdf, Microsoft Word, -Excel, -Powerpoint, kép, rtf)</span></h6>
        <div class="form-box-item form-group file file-drag-and-drop" :class="{invalid: files.length < 1}">
          <input
            type="file"
            name="files"
            class="form-control"
            @change="handleFile"
            accept="application/pdf|application/msword|image/*|application/rtf|text/plain"
            multiple
          >
        </div>
        <div class="file-list">
          <div class="processing" v-if="fileScanning">
            {{fileProcessingInfo}}
            <div class="loading animated fadeIn">
               <div class="bg"></div>
            </div>
          </div>
          <!-- Fájlista -->
          <div class="file-list-item" v-for="(file, index) of files"  v-bind:key="index">
            <div class="left">
              <img :src="getSrc(file)" :title="file.name" v-if="isImage(file)">
              <footer>
                <div class="filename">
                  <a target='_blank' :href="getSrc(file)">
                    {{file.name}}
                    (Méret: {{bytesToSize(file.size)}})
                    <span v-if="processingUpdatesNum && typeof file.visibleCharNum != 'undefined'">(Karakterszám: {{file.visibleCharNum}})</span>
                  </a>
                </div>
                <div class="alert alert-warning" v-if="fileScanningErrors.length > 0 && typeof file.ocrError !='undefined' && file.ocrError">
                  A feltöltött dokumentum nem feldolgozható. Kérjük küdlje el ajánlatkérését e-mailen az <a href="mailto:info@nonstop-forditas.hu">info@nonstop-forditas.hu</a> címre, ezt követően kollégáink felveszik Önnel a kapcsolatot.
                </div>
              </footer>
            </div>
            <button class="right" type="button" @click="removeFile(index)" v-if="!fileScanning">
              <span class="glyphicon glyphicon-remove"></span> Törlés
            </button>
            <div class="loading animated fadeIn thin" style="clear: both" v-if="processingUpdatesNum && file.processing">
               <div class="bg"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="quantityType == 'karakterszam' && qty > 1">
        <hr style="border-top: 2px solid #ddd">
        <h6 class="capital">{{typeLabel}}: <strong>{{qty}}</strong></h6>
      </div>
    </div>
  </section>
</template>
<script>
import {fieldMixin} from '../../mixin/field'

export default {
  data: function(){
    return {
      fileElement: Object,
      fileChars: [],
      fileScanning$: false,
      //a File objektum attribútuma nem reaktív, a reaktivitás miatt használjuk ezt a változót
      fileScanningErrors: [],
      repeats: 0,
      //a dokumenum adatok beállítás alatt vannak
      settingDocument: false,
      fileDocumentInfo: [],
      fileProcessingStatus: 'default',
      //feldolgozás updatek száma (a fájl műveletek változásának detektálására készült)
      processingUpdatesNum: 0
    }
  },
  props: [
    'quantity',
    'quantityType',
    'filesVal',
    'apiUrl',
    'srcLanguage',
    'fileProcessingState',
    'charRepeats',
    'fileScanningHasError',
    'chars',
    'specialization',
    'documentInfo' //need to be array
  ],
  mixins: [
    fieldMixin
  ],
  computed: {
    /* .sync modifier-rel rendelkező props-ok küldése a szülő elemnek  */
    qty: {
      set(val) {
        this.$emit(`update:quantity`, val)
      },
      get(){
        return this.quantity
      }
    },
    //feldolgozáshoz tartozó üzenet
    fileProcessingInfo() {
      if(this.fileProcessingStatus == 'get-stats')
        return '(2/2) Fájl statisztikák lekérdezése...'
      else
        return '(1/2) Karakterszámok lekérdezése... (formátumtól és méretétől függően több percet is igénybe vehet)'
    },
    fileProcessingError() {
      for(let i=0; i<this.files.length; i++) {
        if(typeof this.files[i].ocrError != 'undefined' && this.files[i].ocrError) {
          this.$emit(`update:fileScanningHasError`, true)
          return true
        }
      }
      this.$emit(`update:fileScanningHasError`, false)
      return false
    },
    files: {
      get() {
        return this.filesVal
      },
      set(val) {
        this.$emit('update:filesVal',val)
      }
    },
    fileProcessing() {
      for(let i=0; i<this.files.length; i++) {
        if(typeof this.files[i].processing != 'undefined' && this.files[i].processing) {
          return true
        }
      }
      return false
    },
    typeLabel() {
      let label = 'karakterszám'
      if(
        typeof this.quantityType != 'undefined'
        && typeof this.fieldOptions[this.quantityType] != 'undefined'
        && typeof this.fieldOptions[this.quantityType]['label'] != 'undefined'
      ) {
        label = this.fieldOptions[this.quantityType]['label']
      }
      return label
    },
    // a dokumentumok feldolgozásra került, de nincs statisztika rendelve hozzá
    documentsHasNoStat() {
      for(let i=0; i<this.files.length; i++) {
        if(
          //valamelyik fájlnál van definiálva a docguid, de nincs karakterszám rendelve hozzá
          typeof this.files[i].documentGuid != 'undefined'
          && typeof this.files[i].charNum == 'undefined'
        ) {
          return true
        }
      }
      return false
    },
    fileScanning: {
      get() {
        return this.fileScanning$
      },
      set(value) {
        this.$emit(`update:fileProcessingState`,value)
        this.fileScanning$ = value
      }
    }
  },
  methods: {
    getFileByDocumentGuid(guid) {
      let file = null
      for(let i=0; i < this.files.length; i++ ) {
        if(this.files[i].documentGuid == guid) {
          return this.files[i]
        }
      }
      return file
    },
    handleFile() {
      this.fileElement = event.target
      event.target.files.forEach( (file) => {
        if(this.checkFileIsEnabled(file)) {
          this.files.push(file)
          //check is ocr ready and send
          this.processToOcr(file)
        }
      })
      //reset file input
      event.target.value = ''
    },
    getSrc(file) {
      return URL.createObjectURL(file)
    },
    isImage(file) {
      const acceptedImageTypes = [
        'image/gif',
        'image/jpeg',
        'image/png'
      ]
      return file && acceptedImageTypes.includes(file['type'])
    },
    removeFile(i){
      if(!this.fileScanning) { //fájlok törlésének lockolása ameddig feldolgozás megy a háttérben
        //fájl törlése
        this.files.splice(i, 1)
        //frissíti a dokumentum infókat
        this.updateFileDocumentInfo()
        //statisztikai adatok frissítése (összesítet stat miatt)
        if(this.files.length > 0 && this.quantityType == 'karakterszam') {
          this.getDocumentsStat()
        } else {
          this.refreshStatByFileScan()
        }
      }

    },
    checkFileIsEnabled(file) {
      return (
        this.checkFileIsImage(file)
        || this.checkFileIsPdf(file)
        || this.checkFileIsText(file)
      )
    },
    checkFileIsImage(file) {
      let imgeTypeRegex = /image\/*/;
      return imgeTypeRegex.test(file.type)
    },
    checkFileIsPdf(file) {
      return file.type == "application/pdf"
    },
    checkFileIsText(file) {
      let textTypes = [
        'application/msword',
        // docx mime type is not working
        // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/rtf',
        'text/plain',
      ]
      for(let i=0; i<textTypes.length; i++) {
        if(file.type == textTypes[i]) {
          return true
        }
      }
      let msOfficeExtRegex = /.+\.(docx|xls|xlsx|ppt|pptx)$/
      //check is .docx
      if(msOfficeExtRegex.test(file.name)) {
        return true
      }
      return false
    },
    fileIsOcrReady(file) {
      return ((this.checkFileIsImage(file) || this.checkFileIsPdf(file)) && this.quantityType == 'karakterszam')
    },
    fileIsStatReady(file) {
      return ((!this.checkFileIsImage(file) && !this.checkFileIsPdf(file)) && this.quantityType == 'karakterszam')
    },
    processToOcr(file) {
      if(this.fileIsOcrReady(file)) {
        this.sendToOcr(file)
      }
      else if(this.fileIsStatReady(file)) {
        this.sendToStat(file)
      }
    },
    updateFileScanningState() {
      let scanning = false;
      for(let i=0; i<this.files.length; i++) {
        //valamelyik fájl még feldolgozás alatt van
        if(typeof this.files[i].processing != 'undefined' && this.files[i].processing) {
          scanning = true
          break
        }
      }
      this.fileScanning = scanning
      //fájl változások követésére
      this.processingUpdatesNum++
    },
    setDocumentInfo(file, data) {
      file.documentGuid = data.documentGuid
      file.fileGuid = data.fileGuid
      file.visibleCharNum = data.charNum
      //frissíti a documentum infókat (legyen egy reaktív tömb)
      this.updateFileDocumentInfo()
    },
    setFileStatsData(data) {
      //set file list
      for(let i=0; i < data.length; i++) {
        let file = this.getFileByDocumentGuid(data[i].documentGuid)
        file.repeat = data[i].repeat
        file.charNum = data[i].charNum
      }
      //refresh stat
      this.refreshStatByFileScan()
    },
    refreshStatByFileScan() {
      let
        repeats = [],
        repeat = 0,
        charNum = 0,
        chars = []

      for(let i=0; i<this.files.length; i++) {
        if(typeof this.files[i].charNum != 'undefined') {
          repeat += parseInt(this.files[i].repeat)
          repeats.push(parseInt(this.files[i].repeat))
          charNum += parseInt(this.files[i].charNum)
          chars.push(parseInt(this.files[i].charNum))
        }
      }

      this.repeat = repeat
      this.qty = charNum
      this.$emit(`update:charRepeats`,repeats)
      this.$emit(`update:fileProcessingHasError`,this.fileProcessingError)
      this.$emit(`update:chars`,chars)

    },
    //file küldése az ocr-nek
    sendToOcr(file) {
      let formData = new FormData()
      formData.append(`method`, 'sendToOcr')
      formData.append(`language`, this.srcLanguage)
      formData.append(`files[]`, file)
      file.processing = true
      this.updateFileScanningState()
      this.$http.post(
        this.apiUrl + 'sendToOcr',
        formData
      )
      .then((response) => {
        if(response.data) {
          //has error (success but has errors)
          if(response.data.errors.length > 0) {
            file.ocrError = true
            this.fileScanningErrors.push(file.name)
          } else{
            this.setDocumentInfo(file, response.data)
          }
        }
        file.processing = false
        this.updateFileScanningState()
      })
      .catch( () => {
        file.processing = false
        this.updateFileScanningState()
        this.fileScanningErrors.push(file.name)
        console.log("error")
      })
    },
    sendToStat(file) {
      let formData = new FormData()
      formData.append(`method`, 'sendToStat')
      formData.append(`language`, this.srcLanguage)
      formData.append(`files[]`, file)

      //set scanning state
      file.processing = true
      this.updateFileScanningState()

      this.$http.post(
        this.apiUrl + 'sendToStat',
        formData
      )
      .then((response) => {
        if(response.data) {
          this.setDocumentInfo(file, response.data)

        }
        //set this file scanning state to false and update
        file.processing = false
        this.updateFileScanningState()
        this.fileScanningErrors.push(file.name)
      })
      .catch( () => {
        file.processing = false
        this.updateFileScanningState()
        this.fileScanningErrors.push(file.name)
        console.log("error")
      })
    },
    /**
     * Előállítja dokumentum információkat az apinak
     * @return array of documentinfo
     */
    updateFileDocumentInfo() {
      let info = []
      for(let i=0; i<this.files.length; i++) {
        if(
          typeof this.files[i].documentGuid != 'undefined'
          && typeof this.files[i].fileGuid != 'undefined'
        ) {
          info.push({
            fileGuid: this.files[i].fileGuid,
            documentGuid: this.files[i].documentGuid
          })
        }
      }
      this.fileDocumentInfo = info
      this.$emit('update:documentInfo',info)
    },
    /**
     * Lekérdezi a document id-khez tartozó statisztikákat
     *
     */
    getDocumentsStat() {
      let
        formData = new FormData(),
        //eredeti state mentése
        defState = this.fileProcessingStatus
      formData.append(`language`, this.srcLanguage)
      formData.append(`documentInfo`, JSON.stringify(this.fileDocumentInfo))
      formData.append(`method`, 'getStat')
      this.fileProcessingStatus = 'get-stats'
      this.fileScanning = true
      this.$http.post(
        this.apiUrl + 'getStat',
        formData
      )
      .then((response) => {
        //statisztika beállítása
        this.setFileStatsData(response.data['stat'])
        this.fileProcessingStatus = defState
        this.fileScanning = false
      })
      .catch( () => {
        this.fileProcessingStatus = defState
        this.fileScanning = false

      })
    },
    bytesToSize(bytes) {
       const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
       if (bytes == 0) return '0 Byte'
       let index = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
       return Math.round(bytes / Math.pow(1024, index), 2) + ' ' + sizes[index]
    }
  },
  watch: {
    fileDocumentInfo: function() {
      //dokumentum infók lekérdezése
      //(mikor változtak a docinfok és a folyamatok lezárultak és van olyan doksi, aminek nincs statja)
      if(!this.fileProcessingState && this.documentsHasNoStat) {
        this.getDocumentsStat()
      }
    }
  }
}
</script>
<style media="screen" lang="scss" >
  .quantity-type{
    button.send-files{
      padding: 0 1em;
      text-transform: none;
      line-height: 2em;
      margin: 1em 0.5em;
      &:hover{
        color: yellow;
      }
    }
  }
  .file-list{
    display: flex;
    flex-wrap: wrap;
    .file-list-item{
      width: 100%;
      padding: 2px;
      text-align: left;
      margin: .2em 0;
      padding: .5em;
      &:not(:first-child) {
        border-top: solid 1px #ddd;
        padding-top: 1.5em;
      }
      .filename{
        font-size: 1.2em;
      }
      img{
        max-height: 100px;
      }
    }
    button{
      background: transparent;
      color: red;
      height: 35px;
      line-height: 35px;
      text-align: left;
      &:hover{
        background: transparent;
      }
    }
    .left{
      width: 70%;
      float: left;
    }
    .right{
      float: right;
    }
  }
  .capital{
    text-transform: capitalize;
  }
  .quantity-type{
    .row h6{
      margin-bottom: 5px;
    }
  }
  h6 span.desc{
    font-size: .9em;
  }
@-webkit-keyframes MOVE-BG {
	from {
		-webkit-transform: translateX(0);
	}
	to {
		-webkit-transform: translateX(46px);
	}
}

@keyframes MOVE-BG {
	from {
		transform: translateX(0);
	}
	to {
		transform: translateX(46px);
	}
}

$progress-primary-color: #496ea5;
$progress-secondary-color: lighten(#496ea5,25%);
.processing {
  width: 100%;
  margin: 1em 0;
}
.loading.thin{
  height: 8px;
}
.loading {
	height: auto;
  text-align: center;
  color: #222;
  position: relative;
  overflow: hidden;
  height: 13px;
	margin: 0;
  border-radius: .3em;
  width: 100%;
  background: transparent;
  &>.bg{
    position: absolute;
    left: -46px;
    right: 0;
    top: 0;
    bottom: 0;
    height: 30px;
    background: -webkit-repeating-linear-gradient(
    145deg,
    $progress-primary-color 1px,
    $progress-secondary-color 2px,
    $progress-secondary-color 11px,
    $progress-primary-color 12px,
    $progress-primary-color 20px
    );
    background: repeating-linear-gradient(
    -55deg,
    $progress-primary-color 1px,
    $progress-secondary-color 2px,
    $progress-secondary-color 11px,
    $progress-primary-color 12px,
    $progress-primary-color 20px
    );
    background-color: lightblue;
    -webkit-animation-name: MOVE-BG;
    -webkit-animation-duration: .65s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;

    animation-name: MOVE-BG;
    animation-duration: .65s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
}


</style>
